var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 265,
    viewBox: "0 0 390 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 188.172H68.8448V200.69H90.75V188.172Z",
    fill: "#51B8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.379 197.56H256.603V200.69H275.379V197.56Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.509 200.69H253.474V203.819H278.509V200.69Z",
    fill: "#4C4C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 84.9052H250.345V94.2931H259.733V84.9052Z",
    fill: "#F1961D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.345 84.9052H212.793V88.0345H250.345V84.9052Z",
    fill: "#4C4C4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M303.543 178.785H284.767V203.819H303.543V178.785Z",
    fill: "#51B8BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M337.966 203.819H62.5862V213.207H337.966V203.819Z",
    fill: "#F1961D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.966 203.819H62.5862V213.207H337.966V203.819Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 113.069H156.465C154.737 113.069 153.336 114.47 153.336 116.198V178.784C153.336 180.513 154.737 181.914 156.465 181.914H244.086C245.814 181.914 247.215 180.513 247.215 178.784V116.198C247.215 114.47 245.814 113.069 244.086 113.069Z",
    fill: "#4C4C4C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 119.328H156.465V175.655H244.086V119.328Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 116.589H156.465V119.328H244.086V116.589Z",
    fill: "#B5B5B5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 131.845H156.465V144.362H244.086V131.845Z",
    fill: "#51B8BA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 178.784H247.215V185.043C247.215 186.772 245.815 188.172 244.086 188.172H156.465C154.737 188.172 153.336 186.772 153.336 185.043V178.784Z",
    fill: "#B5B5B5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.664 188.172H190.888L189.323 200.69H211.228L209.664 188.172Z",
    fill: "#B5B5B5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.052 200.69H181.5V203.819H219.052V200.69Z",
    fill: "#B5B5B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.629 150.621H165.853V163.138H184.629V150.621Z",
    fill: "#F1961D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.664 150.621H190.888V163.138H209.664V150.621Z",
    fill: "#F1961D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.052 200.69H181.5V203.819H219.052V200.69Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M209.664 188.172H190.888L189.323 200.69H211.228L209.664 188.172Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.276 185.043C201.14 185.043 201.84 184.343 201.84 183.478C201.84 182.614 201.14 181.914 200.276 181.914C199.412 181.914 198.711 182.614 198.711 183.478C198.711 184.343 199.412 185.043 200.276 185.043Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 178.784H247.215",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 116.589H156.465V175.655H244.086V116.589Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.215 116.198C247.215 114.469 245.815 113.069 244.086 113.069",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M247.215 185.043C247.215 186.772 245.815 188.172 244.086 188.172",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 185.043C153.336 186.772 154.737 188.172 156.465 188.172",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M247.215 185.043V116.198",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 113.069H156.465",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 116.198V185.043",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.465 188.172H244.086",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 119.328H156.465",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 116.198C153.336 114.469 154.737 113.069 156.465 113.069",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M184.629 150.621H165.853V163.138H184.629V150.621Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.664 150.621H190.888V163.138H209.664V150.621Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M194.017 125.586H206.534",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 131.845H156.465",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M244.086 144.362H156.465",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.853 166.267H172.112",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M165.853 169.397H175.241",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M190.888 166.267H209.664",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M197.146 169.397H206.534",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M175.241 166.267H184.629",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.371 169.397H181.5",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M190.888 169.397H194.017",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.922 166.267H222.181",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M215.922 169.397H225.31",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M228.44 169.397H231.569",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M225.31 166.267H228.44",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M231.569 166.267H234.698",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 191.302L118.914 203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 178.784L118.914 191.302",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 166.267L118.914 178.784",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 153.75L118.914 166.267",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 141.233L118.914 153.75",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 191.302L106.396 203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 178.784L106.396 191.302",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 166.267L106.396 178.784",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 153.75L106.396 166.267",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 141.233L106.396 153.75",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 153.75H118.914",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 166.267H118.914",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 178.784H118.914",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 191.302H118.914",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 141.233V203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 141.233V203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 147.491H215.922V160.009H234.698V147.491Z",
    fill: "#F1961D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M297.284 72.3879H222.181V84.9052H297.284V72.3879Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M284.767 84.9052L297.284 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 84.9052L284.767 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 84.9052L272.25 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M247.216 84.9052L259.733 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 84.9052L247.215 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M222.181 84.9052L234.698 72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M284.767 72.3879L297.284 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 72.3879L284.767 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 72.3879L272.25 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M247.216 72.3879L259.733 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 72.3879L247.215 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M222.181 72.3879L234.698 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 147.491L272.25 160.009",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 134.974L272.25 147.491",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 122.457L272.25 134.974",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 109.94L272.25 122.457",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 97.4225L272.25 109.94",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 84.9052L272.25 97.4224",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 147.491L259.733 160.009",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 134.974L259.733 147.491",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 122.457L259.733 134.974",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 109.94L259.733 122.457",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 97.4225L259.733 109.94",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 84.9052L259.733 97.4224",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M222.181 72.3879L209.664 84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M209.664 84.9052H222.181",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 72.388V59.8707",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 59.8707H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 59.8707V72.388",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 72.388L259.733 59.8707",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 72.388L272.25 59.8707",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M278.509 200.69H253.474V203.819H278.509V200.69Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M275.379 197.56H256.604V200.69H275.379V197.56Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 84.9052H250.345V94.2931H259.733V84.9052Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M256.603 88.0345H253.474V91.1639H256.603V88.0345Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M225.31 84.9052V130.28",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 72.3879V84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M247.216 72.3879V84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M284.767 72.3879V84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 97.4225H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 109.94H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 122.457H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 134.974H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 147.491H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 185.043L272.25 197.56",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 172.526L272.25 185.043",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 160.009L272.25 172.526",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 185.043L259.733 197.56",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 172.526L259.733 185.043",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 160.009L259.733 172.526",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 172.526H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 185.043H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 160.009H272.25",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.733 72.3879V197.56",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M272.25 197.56V72.3879",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M226.875 130.28H223.746V136.539H226.875V130.28Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M225.31 138.104C226.171 138.104 226.875 138.808 226.875 139.668C226.875 140.529 226.171 141.233 225.31 141.233C224.45 141.233 223.746 140.529 223.746 139.668",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M225.31 138.104V136.93",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 147.491H215.922V160.009H234.698V147.491Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M219.052 147.491L225.31 141.233",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M225.31 141.233L231.569 147.491",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M249.562 88.0345H212.793",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M212.793 88.0345V84.9052",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M303.543 178.785H284.767V203.819H303.543V178.785Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 197.56C308.401 197.56 309.802 196.16 309.802 194.431V185.043C309.802 183.314 308.401 181.914 306.672 181.914",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 181.914H303.543",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 188.172H68.8448V200.69H90.75V188.172Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5388 203.819C74.4029 203.819 75.1034 203.118 75.1034 202.254C75.1034 201.39 74.4029 200.69 73.5388 200.69C72.6746 200.69 71.9741 201.39 71.9741 202.254C71.9741 203.118 72.6746 203.819 73.5388 203.819Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6682 203.819C77.5323 203.819 78.2328 203.118 78.2328 202.254C78.2328 201.39 77.5323 200.69 76.6682 200.69C75.804 200.69 75.1035 201.39 75.1035 202.254C75.1035 203.118 75.804 203.819 76.6682 203.819Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 200.69H90.75V191.302H97.0086L100.138 194.431V200.69Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8793 191.302V194.431H100.138",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4439 203.819C96.3081 203.819 97.0086 203.119 97.0086 202.254C97.0086 201.39 96.3081 200.69 95.4439 200.69C94.5798 200.69 93.8793 201.39 93.8793 202.254C93.8793 203.119 94.5798 203.819 95.4439 203.819Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8448 197.56H90.75",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 191.302H68.8448",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 200.69H228.44V203.819H234.698V200.69Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M237.828 197.56H231.569V200.69H237.828V197.56Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M240.957 200.69H234.698V203.819H240.957V200.69Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M247.216 200.69H240.957V203.819H247.216V200.69Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M331.707 200.69C329.399 198.773 326.051 197.56 322.319 197.56C318.587 197.56 315.239 198.773 312.931 200.69",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M312.931 200.69V203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M331.707 200.69V203.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M312.931 200.69H319.972",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M322.319 200.69H323.101",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 100.552C164.57 100.552 173.677 91.4449 173.677 80.2111C173.677 68.9774 164.57 59.8706 153.336 59.8706C142.102 59.8706 132.996 68.9774 132.996 80.2111C132.996 91.4449 142.102 100.552 153.336 100.552Z",
    fill: "#51B8BA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 97.4224C162.842 97.4224 170.547 89.7167 170.547 80.2112C170.547 70.7057 162.842 63 153.336 63C143.831 63 136.125 70.7057 136.125 80.2112C136.125 89.7167 143.831 97.4224 153.336 97.4224Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 100.552C164.57 100.552 173.677 91.4449 173.677 80.2111C173.677 68.9774 164.57 59.8706 153.336 59.8706C142.102 59.8706 132.996 68.9774 132.996 80.2111C132.996 91.4449 142.102 100.552 153.336 100.552Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 80.2111V69.2585",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M153.336 80.4068L159.595 77.0193",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M294.155 219.466H327.013",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M251.91 222.595H242.522",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2328 222.595H90.75",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6207 225.724H93.8793",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 66.1294H228.44",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 63H242.522",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M168.983 109.94H172.112",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 219.466H120.478",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M297.285 216.336H265.991",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M316.06 169.397C317.789 169.397 319.19 167.996 319.19 166.267C319.19 164.539 317.789 163.138 316.06 163.138C314.332 163.138 312.931 164.539 312.931 166.267C312.931 167.996 314.332 169.397 316.06 169.397Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M161.16 235.112C162.024 235.112 162.724 234.412 162.724 233.548C162.724 232.683 162.024 231.983 161.16 231.983C160.295 231.983 159.595 232.683 159.595 233.548C159.595 234.412 160.295 235.112 161.16 235.112Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0561 122.457C87.7843 122.457 89.1854 121.056 89.1854 119.328C89.1854 117.599 87.7843 116.198 86.0561 116.198C84.3278 116.198 82.9268 117.599 82.9268 119.328C82.9268 121.056 84.3278 122.457 86.0561 122.457Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M352.047 216.336C352.912 216.336 353.612 215.636 353.612 214.772C353.612 213.907 352.912 213.207 352.047 213.207C351.183 213.207 350.483 213.907 350.483 214.772C350.483 215.636 351.183 216.336 352.047 216.336Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.375 188.173C46.2391 188.173 46.9396 187.472 46.9396 186.608C46.9396 185.744 46.2391 185.043 45.375 185.043C44.5108 185.043 43.8103 185.744 43.8103 186.608C43.8103 187.472 44.5108 188.173 45.375 188.173Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M286.332 50.4827C287.196 50.4827 287.897 49.7822 287.897 48.918C287.897 48.0539 287.196 47.3534 286.332 47.3534C285.468 47.3534 284.767 48.0539 284.767 48.918C284.767 49.7822 285.468 50.4827 286.332 50.4827Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M331.707 141.233H353.612",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M337.965 144.362H325.448",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M309.802 100.552H316.06",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M197.147 216.336H222.181",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9741 150.621H75.1034",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M156.466 53.6121H172.112",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.983 50.4828H175.241",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M203.405 247.629H184.629",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M184.629 244.5H176.806",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M190.888 28.5776H209.664",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M128.302 131.845C133.487 131.845 137.69 127.642 137.69 122.457C137.69 117.272 133.487 113.069 128.302 113.069C123.117 113.069 118.914 117.272 118.914 122.457C118.914 127.642 123.117 131.845 128.302 131.845Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M286.332 150.621C290.652 150.621 294.155 147.118 294.155 142.798C294.155 138.477 290.652 134.974 286.332 134.974C282.011 134.974 278.509 138.477 278.509 142.798C278.509 147.118 282.011 150.621 286.332 150.621Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M211.228 241.371C213.821 241.371 215.922 239.269 215.922 236.677C215.922 234.084 213.821 231.983 211.228 231.983C208.636 231.983 206.534 234.084 206.534 236.677C206.534 239.269 208.636 241.371 211.228 241.371Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 238.241H137.69",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M136.125 236.677V239.806",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M339.53 178.785H342.659",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M341.095 177.22V180.349",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M107.961 80.2112H111.09",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M109.526 78.6466V81.7759",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3621 147.491H56.3276",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M219.052 94.2931H194.017",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M197.147 97.4225H187.759",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M312.931 116.589H361.435",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9741 166.267H31.2931",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M353.612 191.302H363",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M147.078 50.4828H134.56",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M234.698 263.276C236.427 263.276 237.828 261.875 237.828 260.147C237.828 258.418 236.427 257.017 234.698 257.017C232.97 257.017 231.569 258.418 231.569 260.147C231.569 261.875 232.97 263.276 234.698 263.276Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M167.418 25.4483C168.282 25.4483 168.983 24.7478 168.983 23.8836C168.983 23.0195 168.282 22.319 167.418 22.319C166.554 22.319 165.853 23.0195 165.853 23.8836C165.853 24.7478 166.554 25.4483 167.418 25.4483Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M287.897 186.608V200.69",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M287.897 181.914V183.478",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M143.948 166.267H128.302C126.573 166.267 125.172 167.668 125.172 169.397V200.69C125.172 202.418 126.573 203.819 128.302 203.819H143.948C145.676 203.819 147.078 202.418 147.078 200.69V169.397C147.078 167.668 145.676 166.267 143.948 166.267Z",
    fill: "#4C4C4C"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M143.948 166.267H128.302C126.573 166.267 125.172 167.668 125.172 169.397V200.69C125.172 202.418 126.573 203.819 128.302 203.819H143.948C145.676 203.819 147.078 202.418 147.078 200.69V169.397C147.078 167.668 145.676 166.267 143.948 166.267Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M143.948 172.526H128.302V197.56H143.948V172.526Z",
    fill: "white",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 169.397H137.69",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M131.431 194.431H140.819",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 175.655H131.431V178.784H134.56V175.655Z",
    fill: "#51B8BA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M140.819 181.914H137.69V185.043H140.819V181.914Z",
    fill: "#51B8BA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 175.655H131.431V178.784H134.56V175.655Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M140.819 181.914H137.69V185.043H140.819V181.914Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M140.819 175.655H137.69V178.784H140.819V175.655Z",
    fill: "#F1961D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M140.819 175.655H137.69V178.784H140.819V175.655Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 188.172H131.431V191.302H134.56V188.172Z",
    stroke: "#020210",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateApp);
export default __webpack_public_path__ + "static/media/update-app.ef2206b60489c9eceded8e8885d48b69.svg";
export { ForwardRef as ReactComponent };